import { ApiFeedItem } from '@helios/frontend-project';
import { LegacyShapedAssociatedEntity as AssociatedEntity } from '@palmetto/associated-entity';

export type ProjectStage =
  | 'onboarding'
  | 'installerMatching'
  | 'finalizingSystem'
  | 'contracting'
  | 'installation'
  | 'loopField'
  | 'installationVerification'
  | 'activationReview'
  | 'completed'
  | 'cancelled';

export type ProjectType =
  | 'hvac'
  | 'solar'
  | 'consumerSolar'
  | 'energyBackup'
  | 'waterHeater'
  | 'geothermal'
  | 'generator';

export const SOLAR_PROJECT_TYPES: ProjectType[] = ['solar', 'consumerSolar'];

export const isSolarProjectType = (type: ProjectType): boolean => SOLAR_PROJECT_TYPES.includes(type);

export interface PropertyStageHistoryItem {
  stage: ProjectStage;
  createdAt: Date;
}

export interface ProjectResponse {
  _id: string;
  type: ProjectType;
  userIds: string[];
  stage: ProjectStage;
  source: ProjectSource;
  acquisitionChannel?: string;
  stageHistory: PropertyStageHistoryItem[];
  propertyId: string;
  feedItems: ApiFeedItem[];
  associatedEntities: AssociatedEntity[];
}

export enum CancelReason {
  financialConcerns = 'financialConcerns',
  ineligiblePropertyType = 'ineligiblePropertyType',
  choseDifferentFinancialProvider = 'choseDifferentFinancialProvider',
  unhappyWithSalesProcess = 'unhappyWithSalesProcess',
  reasonNotProvided = 'reasonNotProvided',
}

export interface ProjectPatchRequest {
  stage: ProjectStage;
  cancellationReason: CancelReason;
}

export type ProjectSource = 'sabal';

export interface FeedItemReward {
  type: string;
  value?: string | number;
}

export interface ApiFeedItemV2 {
  _id: string;
  type: string;
  status: string;
  ctaType?: string;
  ctaUrl?: string;
  rewards?: FeedItemReward[];
  projectId?: string;
}

export type PointOfContactType = 'sabalOrganization';

export interface PointOfContact {
  email: string;
  phone: string;
  primary: boolean;
  type: PointOfContactType;
  parentEntityName: string;
  firstName?: string;
  lastName?: string;
  organizationId?: string;
}

export interface ProjectV2Response {
  _id: string;
  type: ProjectType;
  stage: ProjectStage;
  source: ProjectSource;
  propertyId: string;
  userIds: string[];
  feedItems: ApiFeedItemV2[];
  pointsOfContact: PointOfContact[];
  associatedEntities: AssociatedEntity[];
  acquisitionChannel?: string;
  stageHistory?: PropertyStageHistoryItem[];
  createdAt?: Date;
  updatedAt?: Date;
}
